module.exports = __webpack_public_path__ + "static/fx_12.b1390235.jpg";